import { useAxiosInterceptors } from "../../config/axios";
import { AxiosInstance } from "axios";
import { isPublishedNow, filterPublishedRelations } from "./Publication";


export const addAuthToHeader = (headers: any, token?: string) => {
  if (token) {
    return { ...headers, Authorization: 'Bearer ' + token }
  } else {
    if (Object.keys(headers).length === 0) {
      return undefined;
    }
    return headers;
  }
}

export class BaseModulePublicApi {
  basePath = '';
  domain = '';
  token: string | undefined;
  axiosInstance: AxiosInstance | undefined;

  constructor(domain: string, token?: string) {
    this.domain = domain;
    this.token = token;
    this.axiosInstance = useAxiosInterceptors();
  }

  async getList(offset: number, limit: number, headers: any, filters: any, orderby: any, configOptions?: any, params?: any,) {
    console.log('getList', `/front/${this.domain}/${this.basePath}`)
    const publicationModule = ['contents', 'points_of_interest'].includes(this.basePath);
    const now = Date.now();
    // Offset is expressed in visible records by callers. Scan raw pages so hidden
    // records cannot shorten a page or cause subsequent visible records to be skipped.
    const visible: any[] = [];
    let rawOffset = publicationModule ? 0 : offset;
    let data: any;
    do {
      const response = await this.axiosInstance!.get(`/front/${this.domain}/${this.basePath}`, {
        headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions,
        params: { ...configOptions?.params, offset: rawOffset, limit, ...orderby, ...filters, ...params,
          ...(publicationModule ? { offset: rawOffset, limit, published_eq: 1 } : {}) },
      });
      if (response.status !== 200) return;
      data = response.data;
      const page = data.results ?? [];
      visible.push(...page.filter((item: any) => !publicationModule || isPublishedNow(item, now))
        .map((item: any) => filterPublishedRelations(item, now)).filter((item: any) => item != null));
      rawOffset += page.length;
      if (!publicationModule || page.length < limit || limit <= 0) break;
    } while (visible.length < offset + limit);
    return { ...data, results: publicationModule ? visible.slice(offset, offset + limit) : visible };

  };

  async get(rowIdSlug: number | string, headers: any, configOptions?: any) {
    console.log('get', `/front/${this.domain}/${this.basePath}/${rowIdSlug}`)
    const response = await this.axiosInstance!.get(`/front/${this.domain}/${this.basePath}/${rowIdSlug}`, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 200) {
      const data = response.data;
      if (['contents', 'points_of_interest'].includes(this.basePath) && !isPublishedNow(data)) return null;
      return filterPublishedRelations(data);
    }
  };

  async create(data: any, headers: any, configOptions?: any) {
    console.log('create', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.post(`/front/${this.domain}/${this.basePath}`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 201) {
      return response.data;
    }
  };

  async duplicate(rowId: number, data: any, headers: any, configOptions?: any) {
    console.log('update', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.post(`/front/${this.domain}/${this.basePath}/${rowId}`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 201) {
      return response.data;
    }
  };

  async update(rowId: number, data: any, headers: any, configOptions?: any) {
    console.log('update', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.put(`/front/${this.domain}/${this.basePath}/${rowId}`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 201) {
      return response.data;
    }
  };

  async delete(rowId: number, headers: any, configOptions?: any) {
    console.log('delete', `/front/${this.domain}/${this.basePath}/${rowId}`)
    const response = await this.axiosInstance!.delete(`/front/${this.domain}/${this.basePath}/${rowId}`, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };

  async deleteBulk(rowIds: number[], headers: any, configOptions?: any) {
    console.log('deleteBulk', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.delete(`/front/${this.domain}/${this.basePath}`, { data: { ids: rowIds }, headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };
};
